import styled from 'styled-components';

export const Filter = styled.div`
  display: flex;
  align-items: center;
  & > div {
    width: 100%;
  }
`;

export const SearchHead = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.primary};
  margin-right: 20px;
  vertical-align: middle;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const FilterDetails = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FilterDetail = styled.div`
  background-color: ${props =>
      props.cursorhandle
      ? props.theme.backgroundColor.layoutLight
      : props.theme.backgroundColor.summaryDivider};
  cursor: ${props => (props.cursorhandle ? 'pointer' : 'not-allowed')};
  font-size: ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.primary};
  border: 1px solid ${props => props.theme.colors.border};
  height: 40px;
  box-sizing: border-box;
  padding: 8px 10px;
  vertical-align: middle;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & span:last-child {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    background-color: ${props =>
      props.cursorhandle
        ? props.theme.backgroundColor.primaryColor
        : props.theme.backgroundColor.disabled};
    vertical-align: sub;
    margin-left: 10px;
    font-size: 12px;
    font-weight: 500;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media only screen and (min-width: 768px) and (max-width: 1023px) {
    padding: 8px 20px;
  }
  @media only screen and (device-width: 1024px) {
    padding: 8px;
    font-size: 14px;
  }
`;
